// Theme + text-size manager
// Theme: "light" | "dark" | "system"
// Text size: "sm" | "md" | "lg" | "xl"
const STORAGE_KEY = "dp-theme";
const SIZE_KEY = "dp-text-size";

export const getStoredTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || "system";
  } catch (_) { /* ignore */ }
  return "system";
};

export const getStoredSize = () => {
  try {
    return localStorage.getItem(SIZE_KEY) || "md";
  } catch (_) { /* ignore */ }
  return "md";
};

export const resolveTheme = (t) => {
  if (t === "light" || t === "dark") return t;
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "light";
};

export const applyTheme = (t) => {
  const resolved = resolveTheme(t);
  const html = document.documentElement;
  if (resolved === "dark") html.classList.add("dark");
  else html.classList.remove("dark");
  return resolved;
};

// Base html font-size for each size preset (default browser base = 16px)
const SIZE_TO_PX = {
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
};

export const applyTextSize = (size) => {
  const px = SIZE_TO_PX[size] || SIZE_TO_PX.md;
  document.documentElement.style.fontSize = px + "px";
  // Also tag body with class so specific overrides can react
  document.documentElement.dataset.textSize = size || "md";
};

export const setTheme = (t) => {
  try { localStorage.setItem(STORAGE_KEY, t); } catch (_) { /* ignore */ }
  applyTheme(t);
};

export const setTextSize = (s) => {
  try { localStorage.setItem(SIZE_KEY, s); } catch (_) { /* ignore */ }
  applyTextSize(s);
};

export const initTheme = () => {
  applyTheme(getStoredTheme());
  applyTextSize(getStoredSize());
  if (typeof window !== "undefined" && window.matchMedia) {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => {
      if (getStoredTheme() === "system") applyTheme("system");
    };
    try { media.addEventListener("change", handler); } catch (_) { /* ignore */ }
  }
};
